var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000034076229515209022850000016629952808289542078_);}\r\n\t.st1{fill:#1C4EC1;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075861028518557340740000017406378954617666736_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_61",
    style: {
      clipPath: "url(#SVGID_00000075861028518557340740000017406378954617666736_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_59",
    className: "st1",
    d: "M2.67,21.33h1.9L17.6,8.3l-1.9-1.9L2.67,19.43V21.33z M0,24v-5.67L17.6,0.77 c0.26-0.24,0.56-0.43,0.88-0.57C18.81,0.07,19.15,0,19.5,0c0.35,0,0.7,0.07,1.03,0.2c0.33,0.13,0.63,0.34,0.87,0.6l1.83,1.87 C23.5,2.9,23.7,3.2,23.82,3.53c0.12,0.32,0.18,0.66,0.18,1c0,0.35-0.06,0.69-0.18,1.02c-0.13,0.33-0.33,0.63-0.58,0.88L5.67,24H0z  M21.33,4.53l-1.87-1.87L21.33,4.53z M16.63,7.37L15.7,6.4l1.9,1.9L16.63,7.37z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEdit);
export default __webpack_public_path__ + "static/media/ico_edit.92a4ad5f7e77b75c2d344c903641c24a.svg";
export { ForwardRef as ReactComponent };